import type { PlateDecodeFields } from "@autorepair/contracts";

/**
 * Master on/off switch for the whole "Decode Plate" feature on the
 * Add/Edit Vehicle page. Off for now because the owner hasn't picked a
 * data source yet — JD Power's own lookup tool is bot-protected (confirmed
 * 403 on both its lookup page and its per-plate report URL, see
 * docs/FRONTEND_BACKLOG.md), so the real choice is between a self-serve
 * alternative (PlateToVIN/CarsXE/vehicledatabases.com) and possibly
 * scraping via a headless browser — undecided either way.
 *
 * Everything the feature needs (contracts, `plate_decodes` cache table,
 * `JdPowerClient`/`PlateDecodeService`, the route, and this UI) stays in
 * the repo and fully working, gated behind this one flag rather than half
 * -removed — so turning it on later is: pick a provider, fill in
 * `JDPOWER_BASE_URL`/`JDPOWER_API_KEY`, flip this to `true`. With it off,
 * VehicleForm renders the License Plate field exactly as it did before
 * this feature existed (a plain input, no state, no button) and never
 * calls `vehiclesApi.decodePlate`.
 */
export const PLATE_DECODER_ENABLED = false;

/** Same idea as VIN_FIELD_LABELS in vinDecode.ts — one list so VehicleForm's
 * read-only "From the Plate" panel can render whatever came back without
 * hardcoding each field twice. */
export const PLATE_FIELD_LABELS: [key: keyof PlateDecodeFields, label: string][] = [
  ["trim", "Trim"],
  ["color", "Color"],
  ["bodyClass", "Body Class"],
  ["engineDescription", "Engine"],
];

/** Two-letter US state/territory codes for the plate-decode lookup dropdown. */
export const US_STATE_CODES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
  "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
  "WV", "WI", "WY",
];
